import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import CentrikaIcon from "../../assets/img/logo.png";
import OperatorLogo from "../../assets/img/operator.jpg";
import SafariLogo from "../../assets/img/logo.svg";

import Transaction from "./transactions.jsx";
import Dashboard from "./dashboard.jsx";
import Commission from "./commissions.jsx";
import Managers from "./managers.jsx";
import AgentManagers from "./agent_managers.jsx";
import Devices from "./devices.jsx";
import Outlet from "./outlet.jsx";
import WalletDetails from "./wallet_details";
import BalanceReport from "./balance_report";
import TxSummaryReport from "./tx_summary_report";
import TxReport from "./tx_report";


import {
  Button,
  Drawer,
  ListItemText,
  IconButton,
  ListItemIcon,
  ListItem,
  Divider,
  List,
  Grid,
  Paper,
  Typography,
  Toolbar,
  AppBar,
  Container,
  Box,
  Hidden,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
  Badge,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Collapse
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  Home,
  Equalizer,
  Settings,
  ExitToApp,
  ArrowDropDown,
  HelpRounded,
  Notifications,
  Group,
  SupervisedUserCircle,
  Store,
  Security,
  AllInclusive,
  Gavel,
  Money,
  Schedule,
  Subway,
  AirportShuttle,
  CreditCard,
  Block,
  Mail,
  Timeline,
  SwapHoriz,
  BorderOuter,
  PeopleAlt,
  Payment,
  PhoneAndroid,
  TurnedInNot,
  ExpandLess,
  ExpandMore,
  ArrowRight,
  PeopleOutline
} from "@material-ui/icons";

import { makeStyles, useTheme } from "@material-ui/styles";

import { withLocalize , Translate } from "react-localize-redux";

import { Link, Switch, Route, useHistory } from "react-router-dom";

import UserInfo from "./login_info";


import {TransportService,AdminService,FinanceService} from "./../../utils/web_config_2";

import { useSnackbar } from 'notistack';


import axios from 'axios';


const routes = [
  {
    path: "/agent",
    exact: true,
    main: () => <Dashboard/>,
  },
  {
    path: "/agent/home",
    exact: true,
    main: () => <Dashboard/>,
  },
  {
    path: "/agent/transactions",
    exact: true,
    main: () => <Transaction/>,
  },
  {
    path: "/agent/commissions",
    exact: true,
    main: () => <Commission/>,
  },
  {
    path: "/agent/balanceRepory",
    exact: true,
    main: () => <BalanceReport />,
  },
  {
    path: "/agent/txSummaryReport",
    exact: true,
    main: () => <TxSummaryReport />,
  },
  {
    path: "/agent/txReport",
    exact: true,
    main: () => <TxReport />,
  },
  {
    path: "/agent/Assistants",
    exact: true,
    main: () => <AgentManagers/>,
  },

  {
    path: "/agent/manager",
    exact: true,
    main: () => <WalletDetails/>,
  },
  {
    path: "/agent/devices",
    exact: true,
    main: () => <Devices/>,
  },

  {
    path: "/agent/outlet",
    exact: true,
    main: () => <Outlet/>,
  },
  {
    path: "/operator/reports",
    exact: true,
    main: () => <Typography>Reports</Typography>,
  },
  {
    path: "/operator/settings",
    exact: true,
    main: () =><Typography>Settings</Typography>,
  },
  {
    main: () => (
      <Box ml={30} p={7} border={1} borderRadius="borderRadius">
        <Typography>Requested url is not found</Typography>
      </Box>
    ),
  },
];

const menus = [
  { name: <Translate id="agent_menu.home"/>, icon: <Home />, path: "/agent/home" },
  { name: <Translate id="agent_menu.sub_agent"/>, icon: <PeopleOutline />, path: "/agent/Assistants" },
  { name: <Translate id="agent_menu.devices"/>, icon: <PhoneAndroid />, path: "/agent/devices" },
  { name: <Translate id="agent_menu.outlet"/>, icon: <TurnedInNot />, path: "/agent/outlet" }, 
  {
    name: "Reports",
    icon: <Timeline />,
    path: "/agent/reports",
    submenu: [
      { name: <Translate id="agent_menu.transactions"/>, icon: <SwapHoriz />, path: "/agent/transactions" },
      { name: <Translate id="agent_menu.commissions"/>, icon: <Payment />, path: "/agent/commissions" },
      { name: "Balance Report", icon: <Payment />, path: "/agent/balanceRepory" },
      { name: "Transaction Summary Report", icon: <Payment />, path: "/agent/txSummaryReport" },
      { name: "Transaction Report", icon: <Payment />, path: "/agent/txReport" }  
    ],
  },
  
];

const menus2 = [
  { name: <Translate id="agent_menu.settings"/>, icon: <Settings />, path: "/agent/settings" },
];

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {
  },
  title: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    border:0
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  btn: {
    textTransform: "capitalize",
  },
  paper: {
    padding: 15,
  },
  icon: {
    height: 45,
    marginRight: 10,
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  operatorLogo:{
    
    height:100
  }
}));

function AgentHome(props) {
  const { window } = props;
  const classes = useStyles();
  const Theme = useTheme();
  const history = useHistory();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const [logoutOpen, setLogoutOpen] = useState(false);

  const [openMenu, setOpenMenu] = useState("none");

  const [agentData,setagentData]=useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      
         <Divider />
         <List>
        {menus.map((menu, index) => (
          <div>
            {" "}
            <ListItem
              button
              key={menu.name}
              onClick={() => {
                if (menu.submenu) {
                  if (openMenu == index) {
                    setOpenMenu("none");
                  } else {
                    setOpenMenu(index);
                  }
                } else {
                  history.push(menu.path);
                }
                setMobileOpen(false);
              }}
              selected={menu.path == history.location.pathname}
            >
              <ListItemIcon>{menu.icon}</ListItemIcon>
              <ListItemText primary={menu.name} />
              {menu.submenu ? (
                openMenu == index ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : (
                <div />
              )}
            </ListItem>
            {menu.submenu && (
              <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {menu.submenu.map((sub, i) => (
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => {
                        history.push(sub.path);
                        setMobileOpen(false);
                      }}
                      selected={sub.path == history.location.pathname}
                    >
                      <ListItemIcon>
                        <ArrowRight />
                      </ListItemIcon>
                      <ListItemText primary={sub.name} />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </div>
        ))}
      </List>
      <Divider />
      <List>
    
      {menus2.map((menu, index) => (
          <ListItem
            button
            key={menu.name}
            onClick={() => {
              if (menu.path === "/operator/logout") {
                setLogoutOpen(true);
              } else {
                history.push(menu.path);
              }
            }}
          >
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.name} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));



  useEffect(()=>{
    var data = {};
    const data1 = localStorage.getItem("nx_ag");
    if (data1 != null) {
      data = JSON.parse(data1);
    
      if (data.token == null) {
        history.replace("/");
        return;
      }
    } else {
      history.replace("/", { expired: true });
    }

  setagentData(data);
  axios.defaults.baseURL = new FinanceService().BASE_URL;


  var dataProfile=JSON.parse(localStorage.getItem('agent_profile'));


  },[]);




  return (
    <div className={classes.root}>
      <CssBaseline />
      <Dialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout of your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_ag");
              localStorage.removeItem("agent_profile");
              history.replace("/");
            }}
            color="primary"
            autoFocus
          >
            
            Logout
          </Button>
        </DialogActions>
      </Dialog>
     
      <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <img src={CentrikaIcon} alt="icon" className={classes.icon} />
          <Box className={classes.title}>
            <Typography variant={matches?"h5":"h6"} noWrap>
              Safari Bus
            </Typography>
          </Box>


          <Box ml={matches&&2}>
          <IconButton color="inherit">
            <Badge
              badgeContent={1}
              showZero={false}
              variant="standard"
              color="secondary"
            >
              <Mail />
            </Badge>
          </IconButton>

          </Box>

<Box ml={matches&&2}>
          <IconButton color="inherit">
            <Badge
              badgeContent={1}
              showZero={false}
              variant="standard"
              color="secondary"
            >
              <Notifications />
            </Badge>
          </IconButton>

          </Box>

          <div>
            <Button
              onClick={handleMenu}
              color="inherit"
              variant={matches&&"outlined"}
              size="small"
              className={classes.btn}
              endIcon={<Avatar>G</Avatar>}
              startIcon={matches&&<img src={SafariLogo} height={35}/>}
            >
              
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>Users</MenuItem>
              <MenuItem onClick={handleClose}>Settings</MenuItem>
              <MenuItem onClick={()=>{
                setLogoutOpen(true);
              }}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="Agent menus">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={Theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          {routes.map((route, i) => (
            <Route
              key={i}
              exact={route.exact}
              path={route.path}
              component={route.main}
            />
          ))}
        </Switch>
      </main>
    </div>
  );
}

export default withLocalize(AgentHome);
